import React from 'react';
import PropTypes from 'prop-types';

import { Heading, Button } from 'components';

import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const RequestStatus = ({
  onClick = () => {},
  isLeftCentered,
  data: {
    icon,
    title,
    description,
    buttonText,
    buttonUrl,
  },
}) => (
  <div className={cx('component', { 'component--left': isLeftCentered })}>
    {icon && <img src={icon} alt="" className={cx('icon')} />}
    <Heading
      isStyled={!isLeftCentered}
      level={1}
      className={cx('title', {
        'title--left': isLeftCentered,
      })}
    >
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </Heading>
    <div className={cx('description', { 'description--left': isLeftCentered })} dangerouslySetInnerHTML={{ __html: description }} />
    <Button transformer className="big" onClick={onClick} href={buttonUrl}>
      {buttonText}
    </Button>
  </div>
);

RequestStatus.propTypes = {
  onClick: PropTypes.func,

  error: PropTypes.shape({
    icon: PropTypes.string,
    titleIcon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    buttonUrl: PropTypes.string,
    isLeftCentered: PropTypes.bool,
  }),
};

export default RequestStatus;
